import { type MCPServerInfo } from '../../types';

const MotherduckServer: MCPServerInfo = {
  serverId: 'MOTHERDUCK',
  name: 'MotherDuck',
  slug: 'motherduck',
  description: 'MotherDuck MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl:
      'https://github.com/motherduckdb/mcp-server-motherduck/tree/main/src/mcp_server_motherduck',
    commitSha: 'a94e4ed',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['motherDuckToken'],
    properties: {
      motherDuckToken: {
        type: 'string',
        description: 'MotherDuck API token',
        sensitive: true
      },
      motherDuckDBPath: {
        type: 'string',
        description: 'Path to the MotherDuck db',
        sensitive: false,
        default: ''
      }
    }
  }
};

export default MotherduckServer;
